module.exports = __webpack_public_path__ + "static/Avoid Duplication 3-37e0ebc8bfd9a16e9e8a2eb6b100c11c.png";